import Main from './components/Main.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import PasswordRecover from './components/PasswordRecover.vue'
import MemberActivate from './components/MemberActivate.vue'

export default [
    {
        name: 'auth.login',
        path: '/login',
        component: Main,
        meta: {
            requiresAuth: false
        }
    },
    {
        name: 'auth.logout',
        path: '/logout',
        redirect: '/login'
    },
    {
        name: 'auth.forgot-password',
        path: '/forgot-password',
        component: ForgotPassword,
        meta: {
            requiresAuth: false
        }
    },
    {
        name: 'auth.password-recover',
        path: '/password-recover/:token',
        component: PasswordRecover,
        meta: {
            requiresAuth: false
        }
    },
    {
        name: 'auth.account-activate',
        path: '/account-activate/:token',
        component: MemberActivate,
        meta: {
            requiresAuth: false
        }
    }
]



// WEBPACK FOOTER //
// ./src/modules/auth/routes.js